import {Schema, String as StringSchema, filter} from 'effect/Schema';
import isUUID from 'validator/lib/isUUID';

export const Uuid = StringSchema.pipe(
    filter((value: string) => isUUID(value), {
        identifier: 'Uuid',
    })
) as unknown as Schema<Uuid>;
type Uuid = import('../src/Uuid').Uuid;
